import {
  AssistantConversationItem,
  ConversationItem,
} from "common/types/conversation";

export function responseInProgress(
  recentMessage: ConversationItem | undefined,
): boolean {
  if (recentMessage === undefined) {
    return false;
  }

  if (recentMessage.role === "user") {
    return true;
  }

  if (recentMessage.role === "assistant" && !recentMessage.llm_meta) {
    // legacy assistant messages without llm_meta
    return false;
  }

  if (recentMessage.role === "assistant") {
    const {
      is_complete,
      has_failed,
    } = (recentMessage as AssistantConversationItem).llm_meta;

    return !is_complete && !has_failed;
  }

  return false;
}
